import {
  CAR_DATA_MASTER_GET_ISO_CURRENCIES_BEGIN,
  CAR_DATA_MASTER_GET_ISO_CURRENCIES_SUCCESS,
  CAR_DATA_MASTER_GET_ISO_CURRENCIES_FAILURE,
  CAR_DATA_MASTER_GET_ISO_CURRENCIES_DISMISS_ERROR,
} from './constants';

import axios from "axios";
import {  REACT_APP_API_ABM_FW } from '../../../common/config';
export function getISOCurrencies() {
  return (dispatch) => {
    dispatch({
      type: CAR_DATA_MASTER_GET_ISO_CURRENCIES_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(REACT_APP_API_ABM_FW + "/iso-currency" );
      doRequest.then(
        (res) => {
          dispatch({
            type: CAR_DATA_MASTER_GET_ISO_CURRENCIES_SUCCESS,
            data: res.data.data,
          });
          resolve(res.data.data);
        },
        (err) => {
          dispatch({
            type: CAR_DATA_MASTER_GET_ISO_CURRENCIES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetISOCurrenciesError() {
  return {
    type: CAR_DATA_MASTER_GET_ISO_CURRENCIES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CAR_DATA_MASTER_GET_ISO_CURRENCIES_BEGIN:
      return {
        ...state,
        getISOCurrenciesPending: true,
        getISOCurrenciesError: null,
      };

    case CAR_DATA_MASTER_GET_ISO_CURRENCIES_SUCCESS:
      return {
        ...state,
        ISOCurrencyList: action.data,
        getISOCurrenciesPending: false,
        getISOCurrenciesError: null,
      };

    case CAR_DATA_MASTER_GET_ISO_CURRENCIES_FAILURE:
      return {
        ...state,
        getISOCurrenciesPending: false,
        getISOCurrenciesError: action.data.error,
      };

    case CAR_DATA_MASTER_GET_ISO_CURRENCIES_DISMISS_ERROR:
      return {
        ...state,
        getISOCurrenciesError: null,
      };

    default:
      return state;
  }
}
